import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { CalendarClock } from "lucide-react";
import { getGoalsDueSoon } from "../lib/api";

/** Dashboard card: upcoming IEP Meeting / Goal Report due dates. Special educators
 * see their own caseload; admins see all. Hidden when there is nothing due soon. */
export default function GoalsDueSoonCard() {
  const [data, setData] = useState({ is_admin: false, items: [] });
  const navigate = useNavigate();

  useEffect(() => {
    getGoalsDueSoon(60).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data.items.length) return null;

  const badge = (d) => {
    if (d < 0) return { text: `${Math.abs(d)}d overdue`, cls: "bg-red-100 text-red-700" };
    if (d === 0) return { text: "Due today", cls: "bg-red-100 text-red-700" };
    if (d <= 14) return { text: `${d}d left`, cls: "bg-amber-100 text-amber-800" };
    return { text: `${d}d left`, cls: "bg-slate-100 text-slate-600" };
  };

  return (
    <Card className="animate-fade-in border-indigo-200" data-testid="goals-due-soon-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2 text-[#00305E]">
          <CalendarClock className="w-4 h-4" />IEP & Goal Report Due Dates
        </CardTitle>
        <CardDescription>{data.is_admin ? "All students" : "Your caseload"} · next 60 days &amp; overdue</CardDescription>
      </CardHeader>
      <CardContent className="space-y-1.5">
        {data.items.map((it, i) => {
          const b = badge(it.days_remaining);
          return (
            <button
              key={`${it.student_id}-${it.type}-${i}`}
              onClick={() => navigate(`/students/${it.student_id}?tab=goals`)}
              className="w-full flex items-center justify-between gap-2 text-left rounded-md px-2 py-1.5 hover:bg-slate-50"
              data-testid={`due-soon-item-${i}`}
            >
              <span className="text-sm text-slate-800 truncate">
                <span className="font-medium">{it.student_name}</span>
                <span className="text-slate-400"> · </span>{it.type}
              </span>
              <span className="flex items-center gap-2 shrink-0">
                <span className="text-xs text-slate-500">{new Date(it.date + "T00:00:00").toLocaleDateString()}</span>
                <span className={`text-xs font-medium px-2 py-0.5 rounded ${b.cls}`}>{b.text}</span>
              </span>
            </button>
          );
        })}
      </CardContent>
    </Card>
  );
}
